import React, { Component } from "react";

class ChangeLog extends Component {


    render() {


        return (
            <div
                style={{

                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    zIndex: 999,
                }}
            >
                <div
                    style={{
                        position: "relative",
                        backgroundColor: "white",
                        border: "1px solid #ccc",
                        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                        padding: "35px",
                        zIndex: 1000,
                    }}
                >
                    <h4
                        style={{
                            margin: "10px 0",
                            fontSize: "20px",
                            color: "#282a65",
                            display: "flex",
                            justifyContent: "center",
                        }}
                    >
                        MyJEEVA Provider Portal Change Log
                    </h4>
                    {/* 2026-11-03 - Version 3.4.3 */}
                    <p>
                        <strong>2026-11-03 Version 3.4.3</strong>
                        <br />
                        Summary: This release lets admins move library folders and sections to another folder
                        of the same treatment library.
                    </p>

                    <ul>
                        <li>
                            Move Library Folders: A new Move button on library folder cards moves a folder, with
                            everything inside it, into another folder of the same treatment library at any
                            depth, or back to Home
                        </li>
                        <li>
                            Move Library Sections: The same Move button on section cards moves a single section
                            into another folder of the library
                        </li>
                        <li>
                            Move Dialog: Folders are listed in the same order as the library and can be searched
                            by name. After a move, a confirmation shows the destination path
                        </li>
                        <li>
                            Emoji Picker: The library text editor now has a full, searchable emoji picker in
                            place of the short emoji list
                        </li>
                    </ul>

                    <p>
                        <strong>Bug fixes:</strong>
                        <br />
                        Cloning a treatment no longer copies hidden library content from deleted folders into
                        the clone. The patient dashboard no longer lists deleted enrollments, and a patient's
                        risk details no longer stay on Loading when they cannot be loaded. The journal and
                        survey scope group dropdowns keep their selection while editing, and service line
                        admins no longer see deactivated treatments in the journal dropdown. Various minor
                        performance improvements and bug fixes
                    </p>

                    <p>
                        <strong>Required User Actions:</strong>
                        <br />
                        No action required
                    </p>

                    <hr />
                    <br />

                    {/* 2026-10-22 - Version 3.4.1 */}
                    <p>
                        <strong>2026-10-22 Version 3.4.1</strong>
                        <br />
                        Summary: This release gives MyJEEVA reminder notifications their own sound.
                    </p>

                    <ul>
                        <li>
                            MyJEEVA Notification Sound: Journal, survey and stand-alone reminder notifications
                            now play a MyJEEVA-specific sound instead of the phone's default notification
                            sound, so patients can tell a MyJEEVA reminder apart from other apps
                        </li>
                    </ul>

                    <p>
                        <strong>Required User Actions:</strong>
                        <br />
                        Patients should update to the latest MyJEEVA app to hear the new notification sound
                    </p>

                    <hr />
                    <br />

                    {/* 2026-10-19 - Version 3.4 */}
                    <p>
                        <strong>2026-10-19 Version 3.4</strong>
                        <br />
                        Summary: This is a major release that introduces the JEEVA AI agent, which answers
                        patients' questions from their treatment library.
                    </p>

                    <ul>
                        <li>
                            JEEVA AI Agent: Patients can ask the JEEVA agent in the MyJEEVA app questions about
                            their treatment, and it answers from the treatment's published library content
                        </li>
                        <li>
                            Treatment-specific Answers: The agent only searches the library of the patient's own
                            treatments, and each conversation is limited to that patient
                        </li>
                        <li>
                            Answers in the Patient's Language: For patients using another language, the agent
                            searches the approved translation of the library as well as the English original
                        </li>
                    </ul>

                    <p>
                        <strong>Required User Actions:</strong>
                        <br />
                        Admins should publish library content and approve its translations so the agent can
                        answer from them. Patients should update to the latest MyJEEVA app to use the agent
                    </p>

                    <hr />
                    <br />

                    {/* 2026-10-05 - Version 3.3.6 */}
                    <p>
                        <strong>2026-10-05 Version 3.3.6</strong>
                        <br />
                        Summary: This is a major release that introduces time-based stand-alone reminders
                        and sends reminder notifications in the patient's own language once approved.
                    </p>

                    <ul>
                        <li>
                            Stand-alone Reminders: Admins can set reminders against a treatment milestone from
                            the new Stand-alone reminder button on the Treatment page. They are not linked to a
                            journal or prescription, so the message itself is the reminder
                        </li>
                        <li>
                            Specific time and Floating time: A Specific time reminder fires at a set time of day,
                            a number of days before or after the milestone. A Floating time reminder is measured
                            from each patient's own milestone date and time using Days, Hours and Minutes offsets
                            (for example, 30 minutes before surgery), so it moves when the milestone moves
                        </li>
                        <li>
                            Patient Milestone Time: Patient milestones now take an optional time, set from the
                            Patient Milestone tab under Manage in Patient Enrollments. Floating time reminders
                            need this time
                        </li>
                        <li>
                            Journal Milestone Date only and Floating time: A Date only journal milestone shows the
                            journal for whole days, from 12:00 AM on the first day to 11:59 PM on the last day. A
                            Floating time journal milestone shows it relative to each patient's own milestone time
                            using Days, Hours and Minutes offsets. Journal reminders are only sent while the
                            journal is available to the patient
                        </li>
                        <li>
                            Stand-alone Reminder Translations: Reminders are translated automatically when saved
                            or when a new language is enabled, and appear in the Translation Approvals tab with
                            one approval button per reminder
                        </li>
                        <li>
                            Translated Reminder Notifications: Journal, survey and stand-alone reminder
                            notifications are sent in the patient's app language when an approved translation
                            exists, and in English otherwise
                        </li>
                        <li>
                            Patient App Reminder Popup: A stand-alone reminder opens as a popup that stays until
                            the patient taps OK, including when opened from the notification tray. Reminders that
                            arrive together are shown one after another
                        </li>
                    </ul>

                    <p>
                        <strong>Bug fixes:</strong>
                        <br />
                        Confirmation and required-field messages no longer appear behind open windows.
                        Survey translation approvals now list every survey of the treatment. Deselecting a
                        language now also clears its library and stand-alone reminder approvals. Various minor
                        performance improvements and bug fixes
                    </p>

                    <p>
                        <strong>Required User Actions:</strong>
                        <br />
                        Admins should add a time to patient milestones that use Floating time reminders or
                        journal milestones, and
                        review and approve stand-alone reminder translations for each active language.
                        Patients should update to the latest MyJEEVA app to see the reminder popup
                    </p>

                    <hr />
                    <br />

                    {/* 2026-09-11 - Version 3.3.4 */}
                    <p>
                        <strong>2026-09-11 Version 3.3.4</strong>
                        <br />
                        Summary: This is a major release introducing LibraryModule architecture for unified content management and collaborative editing across all admins.
                    </p>

                    <ul>
                        <li>
                            Unified Library View: Patients now see all admin contributions for a treatment in one consolidated view (not fragmented by admin)
                        </li>
                        <li>
                            Collaborative Content Editing: All admins can edit and contribute to any treatment's content with unified visibility
                        </li>
                        <li>
                            LibraryModule Architecture: New treatment-centric content model replacing fragmented admin-centric Content records
                        </li>
                    </ul>

                    <p>
                        <strong>Bug fixes:</strong>
                        <br />
                        Various minor performance improvements and bug fixes
                    </p>

                    <p>
                        <strong>Required User Actions:</strong>
                        <br />
                        Admins should verify that all treatment content is properly consolidated in the unified library view. Test collaborative content editing across multiple admin users to ensure changes are visible to all. No manual database migration required (automatic during deployment).
                    </p>

                    <hr />
                    <br />

                    {/* 2026-08-19 - Version 3.3.3 */}
                    <p>
                        <strong>2026-08-19 Version 3.3.3</strong>
                        <br />
                        Summary: This is a minor release that introduces translation approval workflow
                        and multi-language content management features.
                    </p>

                    <ul>
                        <li>
                            Translation Approval Workflow: Admins can now manage and approve translations
                            for surveys, journals, and library content before they are displayed to patients
                        </li>
                        <li>
                            Multi-Language Content Management: Support for managing content translations
                            in multiple languages (Spanish, French, German, Arabic)
                        </li>
                        <li>
                            Language Approval Status Tracking: Visual indicators show the approval status
                            of translations for each language
                        </li>
                        <li>
                            Patient Language Preference: Patients can select their preferred language
                            and content displays accordingly if approved
                        </li>
                    </ul>

                    <p>
                        <strong>Bug fixes:</strong>
                        <br />
                        Various minor performance improvements and bug fixes
                    </p>

                    <p>
                        <strong>Required User Actions:</strong>
                        <br />
                        Admins should review and approve translations for active languages to enable
                        multi-language content display to patients
                    </p>

                    <hr />
                    <br />

                    {/* 2026-05-27 - Version 3.2.7 */}
                    <p>
                        <strong>2026-05-27 Version 3.2.7</strong>
                        <br />
                        Summary: This is a minor release that provides functional enhancements,
                        performance improvements, and bug fixes.
                    </p>

                    <ul>
                        <li>
                            Track patient usage time for compliance or billing purposes. Time records can be accessed
                            from the treatment tab or the patient management section.
                        </li>
                    </ul>

                    <p>
                        <strong>Bug fixes:</strong>
                        <br />
                        Various minor performance improvements and bug fixes
                    </p>

                    <p>
                        <strong>Required User Actions:</strong>
                        <br />
                        None required
                    </p>

                    <hr />
                    <br />

                    {/* 2026-02-17 - Version 3.2.6 */}

                    <p>
                        <strong>2026-02-17 Version 3.2.6</strong>
                        <br />
                        Summary: This is a minor release that provides functional enhancements,
                        performance improvements, and bug fixes.
                    </p>

                    <ul>
                        <li>
                            Send patient surveys at specific points in a treatment lifecycle by tying
                            surveys to treatment milestones (required)
                        </li>
                        <li>
                            Patients may now utilize their phone’s front camera when adding pictures
                            to journals, enhancing the flexibility of the journal picture feature
                        </li>
                        <li>
                            Risk Dashboard loads faster
                        </li>
                    </ul>

                    <p>
                        <strong>Bug fixes:</strong>
                        <br />
                        Various minor performance improvements and bug fixes
                    </p>

                    <p>
                        <strong>Required User Actions:</strong>
                        <br />
                        Update patient surveys to link to a milestone
                        <br />
                        Modify workflows as required to ensure patient milestone status is updated
                        in the MyJEEVA Provider Portal to trigger survey distribution
                    </p>

                    <hr />
                    <br />


                    {/* 2025-11-20 - Version 3.2.5 */}
                    <p>
                        <strong>2025-11-27 Version 3.2.5</strong>
                        <br />
                        Summary: This is a minor release that provides functional enhancements,
                        performance improvements, and bug fixes.
                    </p>
                    <ul>
                        <li>Enable patients to post pictures within journals (new journal answer type: image)</li>
                        <li>View journal pictures from within patient and dashboard journal sections</li>
                    </ul>
                    <p><strong>Bug fixes:</strong> Various minor performance improvements and bug fixes</p>
                    <p>
                        <strong>Required User Actions:</strong>
                        <br />
                        Modify existing journals if you desire patients to capture pictures for review
                    </p>

                    <hr />
                    <br />

                    {/* 2025-09-19 - Version 3.2.4 */}
                    <p>
                        <strong>2025-09-19 Version 3.2.4</strong>
                        <br />
                        Summary: This is a minor release that provides functional enhancements,
                        performance improvements, and bug fixes.
                    </p>
                    <ul>
                        <li>Enable or disable the JEEVA Artificial Intelligence Agent (default: disabled)</li>
                        <li>Green agent icons indicate treatments with enabled AI</li>
                    </ul>
                    <p><strong>Bug fixes:</strong> Various minor performance improvements and bug fixes</p>
                    <p>
                        <strong>Required User Actions:</strong>
                        <br />
                        Modify existing treatments to enable or disable the JEEVA AI agent as desired
                    </p>

                    <hr />
                    <br />

                    {/* 2025-08-07 - Version 3.2.3 */}
                    <p>
                        <strong>2025-08-07 Version 3.2.3</strong>
                        <br />
                        Summary: This is a minor release that provides functional enhancements,
                        performance improvements, and bug fixes.
                    </p>
                    <ul>
                        <li>Create new risk rules incorporating floating baselines (yesterday, N days ago, first journal data point)</li>
                    </ul>
                    <p><strong>Bug fixes:</strong> Various minor performance improvements and bug fixes</p>
                    <p><strong>Required User Actions:</strong><br />None required</p>

                    <hr />
                    <br />

                    {/* 2025-05-27 - Version 3.2.2 */}
                    <p>
                        <strong>2025-05-27 Version 3.2.2</strong>
                        <br />
                        Summary: This is a minor release that provides functional enhancements,
                        performance improvements, and bug fixes.
                    </p>
                    <ul>
                        <li>View patient, treatment, and risk information across providers</li>
                    </ul>
                    <p><strong>Bug fixes:</strong> Various minor performance improvements and bug fixes</p>
                    <p><strong>Required User Actions:</strong><br />None required</p>

                    <hr />
                    <br />

                    {/* 2025-02-19 - Version 3.2.1 */}
                    <p>
                        <strong>2025-02-19 Version 3.2.1</strong>
                        <br />
                        Summary: This is a minor release that provides functional enhancements,
                        performance improvements, and bug fixes.
                    </p>
                    <ul>
                        <li>Access MyJEEVA Provider Portal documentation from the header</li>
                        <li>Access legal terms from the footer</li>
                        <li>Auto-logoff time adjusted to 10 minutes</li>
                    </ul>
                    <p><strong>Bug fixes:</strong> Various minor performance improvements and bug fixes</p>
                    <p><strong>Required User Actions:</strong><br />None required</p>

                    <hr />
                    <br />

                    {/* 2025-01-09 - Version 3.2.0 */}
                    <p>
                        <strong>2025-01-09 Version 3.2.0</strong>
                        <br />
                        Summary: This is a major release providing functional enhancements,
                        performance improvements, and bug fixes.
                    </p>
                    <ul>
                        <li>Display surveys/journals only on patient-specific dates</li>
                        <li>Define treatment standard milestones</li>
                        <li>Define journal/survey milestone offsets</li>
                        <li>Establish patient-specific milestone dates</li>
                        <li>Rapid role switching using top banner dropdown</li>
                    </ul>
                    <p><strong>Bug fixes:</strong> Various minor performance improvements and bug fixes</p>
                    <p>
                        <strong>Required User Actions:</strong>
                        <br />
                        Establish treatment milestones, journal-specific offsets, survey-specific offsets, and incorporate entry of patient-specific milestone dates.
                    </p>
                </div>

            </div>
        );
    }
}

export default ChangeLog;



// WEBPACK FOOTER //
// src/my-jeeva/projectmgmt/ChangeLog.js